import {css} from "lit-element/lit-element.js";
export default css`:host {
  display: contents;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNDE4NTUzMTEwNS9zcmMvcGFja2FnZXMvd2ViY29tcG9uZW50cy9zcmMvY29tcG9uZW50cy9kaXNwbGF5L2F0bGFzLXByaXZhdGUtY29udGVudCIsInNvdXJjZXMiOlsiYXRsYXMtcHJpdmF0ZS1jb250ZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSIsInNvdXJjZXNDb250ZW50IjpbIjpob3N0IHtcbiAgICBkaXNwbGF5OiBjb250ZW50cztcbn1cbiJdfQ== */`;
